let feiShu

const handleScan = async ({ onScanned }) => {
	if (!feiShu) {
		const m = await import(/* webpackChunkName: "chunks/feishuinterface" */ 'tyan/public/interfaces/feiShu')
		m && m.default && (feiShu = m.default)
	}
	feiShu
		? feiShu.scanCode({
			onScaned: ({ code }) => {
				onScanned(code)
			},
			fail: (err) => {
				Tyan.pubForm.showConfirm(JSON.stringify(err), () => { })
			}
		})
		: Tyan.pubForm.showError('系统错误，请与系统管理联系:feishu module not found')
}

export default handleScan